var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIconsTwitterFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6277 5.14305C23.7579 5.52847 22.8235 5.78889 21.8412 5.90659C22.8548 5.30013 23.613 4.34562 23.9745 3.22118C23.0223 3.78679 21.9801 4.18492 20.8933 4.39826C20.1624 3.61791 19.1944 3.10068 18.1395 2.92688C17.0845 2.75308 16.0017 2.93242 15.0592 3.43707C14.1166 3.94171 13.367 4.74343 12.9268 5.71774C12.4866 6.69206 12.3803 7.78446 12.6245 8.82534C10.6951 8.72847 8.80749 8.22696 7.08436 7.35337C5.36123 6.47978 3.84105 5.25364 2.62246 3.75451C2.20579 4.47326 1.96621 5.30659 1.96621 6.19409C1.96575 6.99305 2.16249 7.77976 2.539 8.48444C2.91551 9.18912 3.46013 9.78997 4.12454 10.2337C3.354 10.2092 2.60045 10.001 1.92663 9.62639V9.68889C1.92655 10.8094 2.31416 11.8955 3.02369 12.7628C3.73322 13.6302 4.72097 14.2253 5.81934 14.4472C5.10453 14.6407 4.3551 14.6692 3.62767 14.5306C3.93756 15.4947 4.54121 16.3379 5.35409 16.9419C6.16698 17.546 7.14842 17.8807 8.161 17.8993C6.44208 19.2487 4.31922 19.9806 2.13392 19.9774C1.74682 19.9775 1.36004 19.9549 0.975586 19.9097C3.19379 21.3359 5.77594 22.0929 8.41309 22.0899C17.3402 22.0899 22.2204 14.6962 22.2204 8.28368C22.2204 8.07534 22.2152 7.86493 22.2058 7.65659C23.1551 6.97011 23.9745 6.12003 24.6256 5.14618L24.6277 5.14305Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTwitterFill);
export default __webpack_public_path__ + "static/media/icons-twitter-fill.2b06b7e66649fb7afa775aa376aaf5b8.svg";
export { ForwardRef as ReactComponent };